import { TDAPositionsReportChartFilters } from '../../../models/types'

export const selectDAPositionsChartReportingFilters = ({
  reportingFilters: reportingDAPositionsChartFiltersState,
}: {
  reportingFilters: TDAPositionsReportChartFilters
}): TDAPositionsReportChartFilters => reportingDAPositionsChartFiltersState
